import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';

domReady(() => {
  new Swiper('.swiperProgramNews', {
    navigation: {
      nextEl: '.program-news-arrows .swiper-button-next',
      prevEl: '.program-news-arrows .swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    watchOverflow: true,
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
      360: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
    },
  });
});
